module.exports = __webpack_public_path__ + "img/02-3方案收益.d3f91d5a.svg";